import { styled } from '@mui/material';

import { useEffect, useMemo } from 'react';

import { useSearchParams } from 'react-router';

import { CenteredLoader } from '@app-velocity/ui';

import { SuccessMessage } from './components/SuccessMessage';
import { useAcceptInvitationMutation } from '../../queries/useAcceptInvitationMutation';
import { FailMessage } from './components/FailMessage';

const StyledDiv = styled('div')`
  color: var(--color-neutral-700);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.28px;

  h1 {
    color: var(--color-neutral-900);
    font-size: 24px;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.48px;
  }
`;

export const AcceptProjectInvitationWidget = () => {
  const {
    mutate: sendConfirmation,
    data,
    isPending,
    isError,
    isSuccess,
  } = useAcceptInvitationMutation();
  const [params] = useSearchParams();
  const token = useMemo(() => params.get('token'), [params]);

  useEffect(() => {
    if (!token) {
      return;
    }

    sendConfirmation(token);
  }, [params, sendConfirmation, token]);

  if (isPending) {
    return <CenteredLoader />;
  }

  return (
    <StyledDiv>
      {(isError || !token) && <FailMessage />}
      {isSuccess && (
        <SuccessMessage projectName={data.name} projectId={data.id} />
      )}
    </StyledDiv>
  );
};
